import { ArrowDown, ArrowUp, Clock3, GripVertical, Play, Search, Trash2, Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { CoverArt } from '../components/cover-art';
import { EmptyState } from '../components/empty-state';
import { ProviderBadge } from '../components/provider-badge';
import { TvButton } from '../components/tv-button';
import { useAppState } from '../state/app-state';

function durationLabel(durationMs?: number) {
  if (!durationMs) return '约 4 分钟';
  return `${Math.floor(durationMs / 60_000)}:${String(Math.floor((durationMs % 60_000) / 1000)).padStart(2, '0')}`;
}

export function QueuePage() {
  const { data, removeFromQueue, moveQueue } = useAppState();
  const navigate = useNavigate();
  if (!data) return null;
  if (!data.queue.length) {
    return (
      <EmptyState
        title="点歌台还没有歌曲"
        description="搜索喜欢的歌并加入点歌台，大家可以轮流开唱。"
        action={<TvButton tone="primary" onClick={() => navigate('/search')}><Search size={21} />去点歌</TvButton>}
      />
    );
  }
  const waitMinutes = Math.max(1, Math.round(data.queue.reduce((total, item) => total + (item.song.durationMs ?? 240_000), 0) / 60_000));
  return (
    <div className="queue-page">
      <section className="queue-summary">
        <div><span><Users size={20} />今晚的点歌台</span><strong>{data.queue.length}</strong><small>首待唱</small></div>
        <div><span><Clock3 size={20} />预计总时长</span><strong>{waitMinutes}</strong><small>分钟</small></div>
        <div className="queue-summary__tip"><img src="/brand/pipi-karaoke-mascot.png" alt="" /><p>按上下箭头调整顺序，第一首会自动准备。</p></div>
      </section>
      <section className="queue-list">
        {data.queue.map((item, index) => (
          <article key={item.id} className={`queue-item ${item.status === 'playing' ? 'is-playing' : ''}`} data-tv-focusable tabIndex={0} onClick={() => navigate(`/play/${encodeURIComponent(item.song.id)}`, { state: { queueId: item.id } })}>
            <span className="queue-item__number">{item.status === 'playing' ? <Play size={19} fill="currentColor" /> : String(index + 1).padStart(2, '0')}</span>
            <CoverArt song={item.song} />
            <div className="queue-item__copy">
              <span>{item.status === 'playing' ? '正在演唱' : `第 ${index + 1} 首`}</span>
              <h3>{item.song.title}</h3>
              <p>{item.song.artist} · {durationLabel(item.song.durationMs)}</p>
            </div>
            <ProviderBadge kind={item.song.providerKind} />
            <span className="queue-item__singer"><small>演唱者</small><strong>{item.singer}</strong></span>
            <div className="queue-item__controls">
              <button type="button" aria-label="上移" onClick={(event) => { event.stopPropagation(); void moveQueue(item.id, -1); }} disabled={index === 0}><ArrowUp /></button>
              <button type="button" aria-label="下移" onClick={(event) => { event.stopPropagation(); void moveQueue(item.id, 1); }} disabled={index === data.queue.length - 1}><ArrowDown /></button>
              <button type="button" aria-label="移除" onClick={(event) => { event.stopPropagation(); void removeFromQueue(item.id); }}><Trash2 /></button>
            </div>
            <GripVertical className="queue-item__grip" />
          </article>
        ))}
      </section>
    </div>
  );
}
